import { z } from "zod";

const AD_EXPIRING_UPGRADE_KEYS = [
  "HOMEPAGE_SHOWREEL",
  "SEARCH_FEATURE",
  "URGENT_SALE",
  "HIGHLIGHT",
] as const;

const AD_TRANSIENT_UPGRADE_KEYS = [
  "FACEBOOK_POST",
  "EMAIL_NEWSLETTER",
] as const;

export const AD_UPGRADE_KEYS = [
  ...AD_EXPIRING_UPGRADE_KEYS,
  ...AD_TRANSIENT_UPGRADE_KEYS,
] as const;

export const AD_UPGRADE_KEY_SCHEMA = z.enum(AD_UPGRADE_KEYS, "Invalid upgrade key");

export type AdUpgradeKey = z.infer<typeof AD_UPGRADE_KEY_SCHEMA>;